export const FETCH_COMMISSION_ALL = 'FETCH_COMMISSION_ALL';
export const FETCH_COMMISSION_ALL_SUCCEED = 'FETCH_COMMISSION_ALL_SUCCEED';
export const FETCH_COMMISSION_ALL_FAILED = 'FETCH_COMMISSION_ALL_FAILED';

export const FETCH_COMMISSION_BY_TIME = 'FETCH_COMMISSION_BY_TIME';
export const FETCH_COMMISSION_BY_TIME_SUCCEED = 'FETCH_COMMISSION_BY_TIME_SUCCEED';
export const FETCH_COMMISSION_BY_TIME_FAILED = 'FETCH_COMMISSION_BY_TIME_FAILED';

export const FETCH_COMMISSION_USER = 'FETCH_COMMISSION_USER';
export const FETCH_COMMISSION_USER_SUCCEED = 'FETCH_COMMISSION_USER_SUCCEED';
export const FETCH_COMMISSION_USER_FAILED = 'FETCH_COMMISSION_USER_FAILED';

export const FETCH_COMMISSION_USERS_PAGINATE = 'FETCH_COMMISSION_USERS_PAGINATE';
export const FETCH_COMMISSION_USERS_PAGINATE_SUCCEED = 'FETCH_COMMISSION_USERS_PAGINATE_SUCCEED';
export const FETCH_COMMISSION_USERS_PAGINATE_FAILED = 'FETCH_COMMISSION_USERS_PAGINATE_FAILED';

export const FETCH_COMMISSION_USER_BY_TIME = 'FETCH_COMMISSION_USER_BY_TIME';
export const FETCH_COMMISSION_USER_BY_TIME_SUCCEED = 'FETCH_COMMISSION_USER_BY_TIME_SUCCEED';
export const FETCH_COMMISSION_USER_BY_TIME_FAILED = 'FETCH_COMMISSION_USER_BY_TIME_FAILED';

export const FETCH_TOTAL_REFERRAL = 'FETCH_TOTAL_REFERRAL';
export const FETCH_TOTAL_REFERRAL_SUCCEED = 'FETCH_TOTAL_REFERRAL_SUCCEED';
export const FETCH_TOTAL_REFERRAL_FAILED = 'FETCH_TOTAL_REFERRAL_FAILED';

export const FETCH_LIST_MAP_LEVEL = 'FETCH_LIST_MAP_LEVEL';
export const FETCH_LIST_MAP_LEVEL_SUCCEED = 'FETCH_LIST_MAP_LEVEL_SUCCEED';
export const FETCH_LIST_MAP_LEVEL_FAILED = 'FETCH_LIST_MAP_LEVEL_FAILED';

export const FETCH_LIST_PARTNERS = 'FETCH_LIST_PARTNERS';
export const FETCH_LIST_PARTNERS_SUCCEED = 'FETCH_LIST_PARTNERS_SUCCEED';
export const FETCH_LIST_PARTNERS_FAILED = 'FETCH_LIST_PARTNERS_FAILED';
